module.exports = __webpack_public_path__ + "static/assets/7f2efd6e94c49681aefd05a38716d8f4.svg";